import Vue from 'vue'

export const TIER_TIME_OK = 'ok'
export const TIER_TIME_OUTDATED = 'outdated'
export const TIER_TIME_UNAVAILABLE = 'unavailable'

// task #155: is `time` the start of an offered slot? Empty-safe twin of date.js isValidDate
export function isOfferedSlotStart(deliveryPeriod, time) {
    const days = (deliveryPeriod && deliveryPeriod.days) || {}
    return Object.entries(days).some(
        ([day, ranges]) =>
            Vue.moment(day).isSame(time, 'day') &&
            (ranges || []).some((range) => Vue.moment(range.from).isSame(time, 'minute'))
    )
}

// the store's periods (deliveryPeriod module state) were fetched for the cart's restaurant and the last fetch gave a
// usable answer (a failed fetch, or the API client's undefined on a network error, leaves no fresh periods)
export function periodsUsableForCart(periodState, cartRestaurantId) {
    return (
        !!cartRestaurantId &&
        !!periodState &&
        periodState.committedRestaurantId === cartRestaurantId &&
        !periodState.lastFetchFailed &&
        !!periodState.deliveryPeriod &&
        typeof periodState.deliveryPeriod.days === 'object' &&
        periodState.deliveryPeriod.days !== null
    )
}

// task #155 (spec §3.5): can the selected scheduled time of a tiered restaurant be trusted?
export function tierTimeState({
    period,
    committedRestaurantId,
    committedPrepValue,
    lastFetchFailed,
    cartRestaurantId,
    cartSubtotal,
    isAsap,
    time,
    isCanteen,
}) {
    if (!period || period.preparation_time == null) return TIER_TIME_OK // untiered (U1)
    if (!cartRestaurantId || committedRestaurantId !== cartRestaurantId) return TIER_TIME_OK
    if (isAsap || !time || isCanteen) return TIER_TIME_OK
    if (committedPrepValue !== cartSubtotal) {
        return lastFetchFailed ? TIER_TIME_UNAVAILABLE : TIER_TIME_OUTDATED
    }
    return isOfferedSlotStart(period, time) ? TIER_TIME_OK : TIER_TIME_UNAVAILABLE
}
